import { useState } from 'react';

/**
 * Tema del pannello: come il sistema, chiaro o scuro, ricordato su questo dispositivo
 * (`localStorage` `sse.admin.theme`). Lo applica `public/theme.js` prima del primo disegno; i
 * colori sono gli stessi token del sito (`@sse/ui/theme-dark.css`).
 */
export type ThemePref = 'auto' | 'light' | 'dark';
const KEY = 'sse.admin.theme';
const ORDER: ThemePref[] = ['auto', 'light', 'dark'];

function read(): ThemePref {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'light' || t === 'dark' ? t : 'auto';
  } catch {
    return 'auto';
  }
}

function apply(t: ThemePref) {
  if (t === 'auto') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = t;
  try {
    if (t === 'auto') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    // vale per questa visita
  }
}

/** Tema attuale e passaggio al successivo (come il sistema → chiaro → scuro). */
export function useTheme() {
  const [theme, setTheme] = useState<ThemePref>(read);
  const next = () => {
    const t = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length]!;
    apply(t);
    setTheme(t);
  };
  return { theme, next };
}
